import axios from 'axios';

const redirectWhenExpired = () => {
  return axios.interceptors.response.use((response) => {
    // Do something with response data
    return response;
  }, (error) => {
    if (error.response && error.response.data.error === "Provided token is expired.") {
      localStorage.clear();
      window.location.reload(true);
    }

    return Promise.reject(error);
  });

}

export default {redirectWhenExpired};


// WEBPACK FOOTER //
// ./src/app/utils/validations/network.js